import { ApplicationData } from './application-data';
import { Validator } from './validator';

export class CareTypeValidator implements Validator {
    public validate(data: ApplicationData): boolean {
        return data.careType != null;        
    }
}
